export interface ObservabilityProvider {
  error(error: Error, context?: Record<string, string>): void;
  warn(message: string, context?: Record<string, string>): void;
  log(message: string, context?: Record<string, string>): void;
}

const noopProvider: ObservabilityProvider = {
  error: () => {},
  warn: () => {},
  log: () => {},
};

let activeProvider: ObservabilityProvider = noopProvider;

export const observability: ObservabilityProvider = {
  error: (error, context) => activeProvider.error(error, context),
  warn: (message, context) => activeProvider.warn(message, context),
  log: (message, context) => activeProvider.log(message, context),
};

export function setObservabilityProvider(
  provider: ObservabilityProvider,
): void {
  activeProvider = provider;
}
